import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { waLink } from "@/config";

const SERVICES = [
  {
    id: "passagens",
    num: "01",
    span: "lg:col-span-7",
    badge: "Passagens Aéreas",
    title: "Passagens Aéreas Internacionais & Nacionais",
    desc: "Emissão simplificada, suporte para alterações, milhas e tarifas corporativas exclusivas para qualquer lugar do mundo.",
    action: "Cotar Passagem no WhatsApp",
    message:
      "Olá, A.S.F Viagens! Gostaria de cotar uma passagem aérea. Podem me ajudar?",
    img: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=1400&auto=format&fit=crop",
  },
  {
    id: "dhl",
    num: "02",
    span: "lg:col-span-5",
    badge: "Logística DHL",
    title: "Envios Internacionais DHL Express",
    desc: "Ponto autorizado DHL. Envie documentos, encomendas e cargas com rastreamento global e entrega ultra-rápida.",
    action: "Calcular Frete DHL",
    message:
      "Olá, A.S.F Viagens! Gostaria de calcular um frete internacional DHL Express.",
    img: "https://images.unsplash.com/photo-1553413077-190dd305871c?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "loja-roupas",
    num: "03",
    span: "lg:col-span-5",
    badge: "Moda & Vestuário",
    title: "Loja de Roupas — Moda & Acessórios",
    desc: "Peças selecionadas com curadoria especial: moda masculina, feminina e acessórios para você viajar com muito estilo.",
    action: "Conhecer a Loja",
    message:
      "Olá, A.S.F Viagens! Gostaria de conhecer as novidades da loja de roupas.",
    img: "/images/loja-araras.jpeg",
  },
  {
    id: "western-union",
    num: "04",
    span: "lg:col-span-7",
    badge: "Remessa Financeira",
    title: "Western Union & Transferências de Câmbio",
    desc: "Envie e receba dinheiro do exterior em minutos com as melhores taxas do mercado e segurança garantida.",
    action: "Consultar Câmbio",
    message:
      "Olá, A.S.F Viagens! Gostaria de consultar taxas para transferência Western Union / câmbio.",
    img: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "naturalizacao",
    num: "05",
    span: "lg:col-span-12",
    badge: "Serviços de Imigração",
    title: "Naturalização Brasileira & Vistos",
    desc: "Assessoria jurídica especializada para obtenção de cidadania brasileira, permanência, vistos e regularização de estrangeiros.",
    action: "Falar com Especialista em Cidadania",
    message:
      "Olá, A.S.F Viagens! Gostaria de falar com um especialista sobre naturalização brasileira.",
    img: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1400&auto=format&fit=crop",
  },
];

const handleMouseMove = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
};

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="bg-ivory py-20 lg:py-32">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold-bronze mb-5">
          Nossos Serviços
        </p>
        <h2
          data-testid="services-title"
          className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-snug text-navy max-w-2xl"
        >
          Capítulos do nosso manifesto:{" "}
          <em className="italic text-gold-bronze">cinco especialidades</em>, um
          único padrão de excelência.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} className={s.span} delay={i * 0.08}>
            <article
              data-testid={`service-card-${s.id}`}
              onMouseMove={handleMouseMove}
              className="spotlight-card group relative h-full min-h-[380px] rounded-2xl overflow-hidden flex flex-col justify-end p-6 sm:p-8 lg:p-10 bg-navy"
            >
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-40 transition-transform duration-[1.4s] ease-out group-hover:scale-110 group-hover:opacity-50"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-navy/10" />

              <div className="relative z-10">
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono text-sm text-gold tracking-[0.3em]">
                    CAP. {s.num}
                  </span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ivory/80 border border-ivory/25 rounded-full px-3 py-1.5">
                    {s.badge}
                  </span>
                </div>
                <h3 className="font-serif text-xl sm:text-2xl font-medium text-ivory leading-snug max-w-md">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm sm:text-base text-ivory/65 leading-relaxed max-w-lg">
                  {s.desc}
                </p>
                <a
                  href={waLink(s.message)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-6 inline-flex items-center gap-2 text-gold font-semibold text-sm group/link"
                >
                  {s.action}
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1.5" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
